<template>
  <div class="d-flex align-center">
    <div v-if="percentage !== undefined" class="d-flex align-center">
      <div class="battery-container mr-3">
        <div class="battery-body" :class="batteryClass">
          <div class="battery-level" :style="batteryLevelStyle"></div>
        </div>
        <div class="battery-tip"></div>
      </div>
      <div v-if="showText" class="d-flex align-center">
        <span class="text-h4 font-weight-bold mr-2"
          >{{ batteryLevel }}%</span
        >
        <span
          class="text-caption grey--text"
          v-if="$route.fullPath.includes('device')"
          >Battery</span
        >
      </div>
    </div>
    <div v-else class="text-center">Loading battery data...</div>
  </div>
</template>

<script>
export default {
  name: "BatteryIndicator",
  data() {
    return {
      animatedPercentage: 0,
    };
  },
  props: {
    percentage: {
      type: Number,
      default: 0,
      validator: (value) => value >= 0 && value <= 100,
    },
    scale: {
      type: Number,
      default: 1,
    },
    showText: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    percentage: {
      immediate: true,
      handler(newVal) {
        const start = this.animatedPercentage;
        const end = newVal;
        this.animateValue(start, end, 2000);
      },
    },
  },
  methods: {
    animateValue(start, end, duration) {
      const range = end - start;
      let current = start;
      const increment = end > start ? 1 : -1;
      const stepTime = Math.abs(Math.floor(duration / range));
      const timer = setInterval(() => {
        current += increment;
        this.animatedPercentage = current;
        if (current >= end) {
          clearInterval(timer);
        }
      }, stepTime);
    },
  },
  computed: {
    fillWidth() {
      const width = (this.animatedPercentage / 100) * 30;
      return `${width}px`;
    },
    fillColor() {
      const percent = this.animatedPercentage;
      if (percent > 60) return "#4CAF50"; // Green
      if (percent > 20) return "#FFA726"; // Orange
      return "#EF5350"; // Red
    },
    batteryClass() {
      const percent = this.animatedPercentage;
      if (percent > 60) return "battery-body-green";
      if (percent > 20) return "battery-body-orange";
      return "battery-body-red";
    },
    batteryLevelStyle() {
      const width = (this.animatedPercentage / 100) * 30;
      return { width: `${width}px` };
    },
    batteryLevel() {
      return this.animatedPercentage.toFixed(0);
    },
  },
};
</script>

<style scoped>
.battery-container {
  display: flex;
  align-items: center;
  gap: 2px;
}

.battery-body {
  width: 40px;
  height: 20px;
  border: 2px solid #666;
  border-radius: 3px;
  position: relative;
  background-color: #f0f0f0;
  overflow: hidden;
}

.battery-level {
  height: 100%;
  background-color: #4CAF50;
  transition: width 0.5s ease-in-out;
  border-radius: 1px;
}

.battery-tip {
  width: 3px;
  height: 10px;
  background-color: #666;
  border-radius: 0 2px 2px 0;
}

.battery-body-green .battery-level {
  background-color: #4CAF50;
}

.battery-body-orange .battery-level {
  background-color: #FFA726;
}

.battery-body-red .battery-level {
  background-color: #EF5350;
}
</style>
